
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newarrival",
      function () {
        return require("private-next-pages/newarrival/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newarrival"])
      });
    }
  